import { useMemo } from 'react'
import {
  useLocation
} from "react-router-dom";

//const Params = useGetQueryParam()
// Params.get('name')
export const useGetQueryParam = () => {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
}